import React from 'react'
import BackButton from '../UI/BackButton'
import PageTitle from '../UI/PageTitle'

const ProjectTypeNotFound = () => (
  <section>
    <header>
      <PageTitle>
        Project type not found!
      </PageTitle>
    </header>
    <br/>
    <BackButton/>
  </section>
)

export default ProjectTypeNotFound



// WEBPACK FOOTER //
// ./src/components/ProjectTypes/ProjectTypeNotFound.jsx